module.exports = __webpack_public_path__ + "img/sri.5c8732d1.png";